import React from "react";
import HistoricLineChart from "./HistoricLineChart";
import { parseState } from "src/lib/historyChart";

export default function CameraStateGraph(props) {
  return (
    <HistoricLineChart
      title="Camera State Graph"
      subject="camera status"
      history={props.historicCameraState}
      parse={parseState}
      kind="state"
      yLabel="State"
      startDate={props.startDate}
      endDate={props.endDate}
    />
  );
}
